import { useDispatch, useSelector } from "react-redux";
import { updateCampaignState } from "../../VideoActions";
import { useNavigate } from "react-router-dom";
import {
  updateCampaignFields,
  updateCampaignState as updateCreateCampaignState,
} from "../../../CreateCampaign/CampaignActions";

const CampaignHeader = () => {
  const videoData = useSelector(
    (state) => state.videoData.campaign_details_list
  );
  const campaignData = videoData?.campaign_details;
  const campaignProduct = campaignData?.products?.map(
    (product) => product?.name
  );
  const campaignBrand = campaignData?.manufacturer?.name;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleQrClick = (campaignId) => {
    if (campaignId) {
      const queryParams = new URLSearchParams();
      queryParams.append("id", campaignId);
      navigate("/create_campaign?" + queryParams.toString());
      dispatch(updateCreateCampaignState({ activeStep: 4 }));
      dispatch(updateCampaignState({ showCampaignStep: true }));
    }
  };

  return (
    <div className="list">
      <div className="box">
        <div className="num-of">
          <div className="label">No. of Videos Collected</div>
          <div className="numb">{videoData?.video_count || 0}</div>
        </div>
      </div>
      <div className="box">
        <div className="num-of">
          <div className="label">No. of Campaign Clicks</div>
          <div className="numb">{campaignData?.clicks || 0}</div>
        </div>
      </div>

      <div className="box">
        <div className="duration">
          <div className="label text-center">Campaign Duration</div>
          <div className="numb">
            {new Date(campaignData?.start_date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })}{" "}
            -{" "}
            {campaignData?.ongoing
              ? "Ongoing"
              : new Date(campaignData?.end_date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
          </div>
        </div>
      </div>

      <div className="box">
        <div className="duration">
          <div className="label text-center">
            Campaign Type -{" "}
            {campaignProduct?.length === 0 ? "Brand" : "Product"}
          </div>
          <div className="numb">
            {campaignProduct?.length === 0 ? campaignBrand : campaignProduct}
          </div>
        </div>
      </div>
      <div className="box">
        <div className="score">
          <div className="label text-center">Overall Sentiment Score</div>
          <div className="score-ellipse">
            {videoData?.overall_sentiment_score || 0}
          </div>
        </div>
      </div>
      <div
        className="toggle-label"
        role="button"
        onClick={() => handleQrClick(campaignData?._id)}
      >
        View Campaign
      </div>
    </div>
  );
};
export default CampaignHeader;
